import React from 'react';
import {useTranslate} from "../useTranslate";
import {useSelector} from "react-redux";

function DropdownItemTemplate(option, props) {

    const translate = useTranslate();
    return (
        <div className={`${!option&&"p-0"}`}>
            <span style={{padding:'1px'}} className="text-xs">{option&&`${translate(option.label??option)}`}</span>
        </div>
    );
}

export default DropdownItemTemplate;